export type TekstinMuutoksenTyyppi = 'lisatty' | 'poistettu' | 'ennallaan'

export interface TekstinMuutos {
  teksti: string
  tyyppi: TekstinMuutoksenTyyppi
}

// Vertailutaulukon koko kasvaa vertailtavien osien pituuksien tulona. Rajan ylittyessä
// muuttunut kohta näytetään kokonaan poistettuna ja lisättynä, ettei selain jumitu.
const VERTAILUTAULUKON_MAKSIMIKOKO = 2_000_000

export function laskeTekstinMuutokset(vanha: string, uusi: string): TekstinMuutos[] {
  const rivimuutokset = _vertaaTokeneita(_pilkoRiveiksi(vanha), _pilkoRiveiksi(uusi))
  const tulos: TekstinMuutos[] = []
  for (let i = 0; i < rivimuutokset.length; i++) {
    const muutos = rivimuutokset[i]
    const seuraava = rivimuutokset[i + 1]
    if (muutos.tyyppi === 'poistettu' && seuraava?.tyyppi === 'lisatty') {
      for (const sanamuutos of _vertaaTokeneita(_pilkoSanoiksi(muutos.teksti), _pilkoSanoiksi(seuraava.teksti))) {
        _lisaa(tulos, sanamuutos.teksti, sanamuutos.tyyppi)
      }
      i++
    } else {
      _lisaa(tulos, muutos.teksti, muutos.tyyppi)
    }
  }
  return tulos
}

function _pilkoRiveiksi(teksti: string) {
  return teksti ? teksti.split(/(?<=\n)/) : []
}

function _pilkoSanoiksi(teksti: string) {
  return teksti.match(/\s+|[\p{L}\p{N}_]+|[^\s\p{L}\p{N}_]/gu) ?? []
}

function _vertaaTokeneita(vanhat: string[], uudet: string[]) {
  let alku = 0
  while (alku < vanhat.length && alku < uudet.length && vanhat[alku] === uudet[alku]) {
    alku++
  }
  let loppu = 0
  while (loppu < vanhat.length - alku && loppu < uudet.length - alku && vanhat[vanhat.length - 1 - loppu] === uudet[uudet.length - 1 - loppu]) {
    loppu++
  }

  const tulos: TekstinMuutos[] = []
  _lisaa(tulos, vanhat.slice(0, alku).join(''), 'ennallaan')
  const keskiosanMuutokset = _vertaaKeskiosa(vanhat.slice(alku, vanhat.length - loppu), uudet.slice(alku, uudet.length - loppu))
  for (const muutos of keskiosanMuutokset) {
    _lisaa(tulos, muutos.teksti, muutos.tyyppi)
  }
  _lisaa(tulos, vanhat.slice(vanhat.length - loppu).join(''), 'ennallaan')
  return tulos
}

function _vertaaKeskiosa(vanhat: string[], uudet: string[]) {
  const tulos: TekstinMuutos[] = []
  if ((vanhat.length + 1) * (uudet.length + 1) > VERTAILUTAULUKON_MAKSIMIKOKO) {
    _lisaa(tulos, vanhat.join(''), 'poistettu')
    _lisaa(tulos, uudet.join(''), 'lisatty')
    return tulos
  }

  const leveys = uudet.length + 1
  const yhteisetPituudet = new Uint32Array((vanhat.length + 1) * leveys)
  for (let i = vanhat.length - 1; i >= 0; i--) {
    for (let j = uudet.length - 1; j >= 0; j--) {
      yhteisetPituudet[i * leveys + j] =
        vanhat[i] === uudet[j] ? yhteisetPituudet[(i + 1) * leveys + j + 1] + 1 : Math.max(yhteisetPituudet[(i + 1) * leveys + j], yhteisetPituudet[i * leveys + j + 1])
    }
  }

  let poistetut = ''
  let lisatyt = ''
  const kirjaaMuutokset = () => {
    _lisaa(tulos, poistetut, 'poistettu')
    _lisaa(tulos, lisatyt, 'lisatty')
    poistetut = ''
    lisatyt = ''
  }

  let v = 0
  let u = 0
  while (v < vanhat.length || u < uudet.length) {
    if (v < vanhat.length && u < uudet.length && vanhat[v] === uudet[u]) {
      kirjaaMuutokset()
      _lisaa(tulos, vanhat[v], 'ennallaan')
      v++
      u++
    } else if (u >= uudet.length || (v < vanhat.length && yhteisetPituudet[(v + 1) * leveys + u] >= yhteisetPituudet[v * leveys + u + 1])) {
      poistetut += vanhat[v]
      v++
    } else {
      lisatyt += uudet[u]
      u++
    }
  }
  kirjaaMuutokset()
  return tulos
}

function _lisaa(muutokset: TekstinMuutos[], teksti: string, tyyppi: TekstinMuutoksenTyyppi) {
  if (!teksti) {
    return
  }
  const edellinen = muutokset[muutokset.length - 1]
  if (edellinen?.tyyppi === tyyppi) {
    edellinen.teksti += teksti
  } else {
    muutokset.push({ teksti, tyyppi })
  }
}
